import { createStore, applyMiddleware } from 'redux';  // legacy_createStore as createStore,
import thunk from 'redux-thunk';
import { persistStore, persistReducer, purgeStoredState } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
import storage from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';

import rootReducer from './reducers/rootReducer';
import { searchSysLanguages, getCmsData } from './actions/userActions';
import { LocalStorage, removeStorage } from '../utils/storage';
import { I18_NEXT_LNG, LANGUAGE, USER_AREA_LIST, USER_DEFAULT_AREA, USER_LOGIN_METHOD, USER_NAME, WEBSITE_CODE, WEBSITE_ID, WEBSITE_SELECTED } from './types';
// ==============================|| REDUX - MAIN STORE ||============================== //

// 配置
const persistConfig = {
  key: 'ROOT',
  keyPrefix: 'SIM_',
  storage,
  // 查看 'Merge Process' 部分的具体情况
  stateReconciler: autoMergeLevel2,
  // 黑名单，不缓存，设置某个reducer数据不持久化，或者可以设置白名单(whitelist)
  // 'service'
  blacklist: ['slices', 'message']
};


// const store = createStore(rootReducer, applyMiddleware(thunk));
const persister = 'Central General Affairs Service';

const appReducer = (state, action) => {
  if (action.type === 'RESET_APP') {
    return rootReducer(undefined, action)
  }
  return rootReducer(state, action)
}

// 持久化根reducer和配置,并返回所有
const reduxReducer = persistReducer(persistConfig, appReducer);

// 创建 持久化store对象
const store = createStore(reduxReducer, applyMiddleware(thunk));
// 持久化store对象
const persistor = persistStore(store);

const resetStore = () => {
  const lang = LocalStorage.get(I18_NEXT_LNG) || LANGUAGE.tw;
  // Reset state to default values
  // this.store.dispatch(resetState());

  // Clear Storage
  removeStorage(USER_NAME);
  removeStorage(USER_LOGIN_METHOD);
  removeStorage(WEBSITE_ID);
  removeStorage(WEBSITE_CODE);
  removeStorage(WEBSITE_SELECTED);
  removeStorage(USER_DEFAULT_AREA);
  removeStorage(USER_AREA_LIST);
  window.sessionStorage.removeItem(WEBSITE_ID);
  window.sessionStorage.removeItem(WEBSITE_CODE);
  // Clear history
  // this.store.dispatch(ActionCreators.clearHistory());
  store.dispatch({type: 'RESET_APP'});

  storage.removeItem('persist:root');

  store.dispatch(searchSysLanguages(lang));

  store.dispatch(getCmsData());

  // Purge persistent store
  persistor?.purge(); // optional: clear storage if needed
  persistor?.flush(); // optional: flush storage to make sure state is persisted immediately

  return purgeStoredState(persistConfig);
};

export { store, persistor, persister, resetStore };
